<template>
  <el-row>
    <el-form label-width="120px">
      <el-row>
        <el-col class="padding-right-xs">
          <el-row class="twice">
            <el-form-item label="网站标题">
              <el-input rows="4" placeholder="例如：企业责任田风险监控平台" v-model="setting.site_title"> </el-input>
            </el-form-item>
            <el-form-item label="网站LOGO"> <l-upload-img v-model="setting.site_head_logo"> </l-upload-img> </el-form-item>
            <el-form-item label="管理员LOGO"> <l-upload-img v-model="setting.site_user_logo"> </l-upload-img> </el-form-item>
          </el-row>
          <el-row class="padding">
            <el-button type="primary" @click="save" class="margin">保 存</el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </el-row>
</template>
<script>
import LUploadImg from '@/lgh/components/uploadimg'
export default {
  components: { LUploadImg },
  props: {
    setting: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      dataInfo: {}
    }
  },
  mounted() {},
  methods: {
    async save() {
      var r = await this.$lgh.post('api/enterprise/setting/addoredit', this.setting)
      console.log(r)
      location.reload()
    }
  }
}
</script>
